import { DOCUMENT_COMPONENT_TYPES } from "../constants/document";

// oldTags = [1,2,3,4,5] newUpdatedTags=[2, 3, 6] => return [1,2,3,4,5,6]
export const getCombinedTags = (oldTags, newUpdatedTags) => {
  const oldTagIds = new Set();
  const newUpdatedTagsMap = {};
  for (let i = 0; i < newUpdatedTags.length; i += 1) {
    const tag = newUpdatedTags[i];
    newUpdatedTagsMap[tag.id] = tag;
  }
  return [
    ...oldTags.map(ot => {
      oldTagIds.add(ot.id);
      if (ot.id in newUpdatedTagsMap) {
        return newUpdatedTagsMap[ot.id];
      }
      return ot;
    }),
    ...newUpdatedTags.filter(nut => !oldTagIds.has(nut.id)),
  ];
};

export const signatureIsAdded = tags => {
  if (tags && Array.isArray(tags) && tags.length > 0) {
    for (let i = 0; i < tags.length; i += 1) {
      const tag = tags[i];
      if (tag && tag.signer_config && tag.signer_config.options) {
        const {
          signer_config: { options },
        } = tag;
        if (options.find(op => op.id === "signature" && op.checked))
          return true;
      } else {
        return false;
      }
    }
  }
  return false;
};

export const isSignersListValidV2 = (components, signatoriesV2) => {
  if (!Array.isArray(signatoriesV2) || signatoriesV2.length < 1) {
    return false;
    // atleast one should be present
  }

  const addedTags = signatoriesV2.filter(signatory =>
    signatureIsAdded(signatory.tags),
  );
  if (addedTags.length < 1) {
    // atleast one should be added
    return false;
  }

  // check if there is any empty signature block or NOT
  const sigComponents = components
    ? Object.keys(components).filter(
        component_id =>
          components[component_id].content.type ===
          DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER,
      )
    : [];

  let emptySigComp = false;

  sigComponents.forEach(component_id => {
    let found = false;
    // check if the component id is availble in any sig tags or not
    signatoriesV2.forEach(signer => {
      const { tags } = signer;
      const compTag = tags.find(tag => tag.component_id === component_id);

      if (compTag) found = true;
    });
    if (found === false) emptySigComp = true;
  });

  // all added tags should have valid info
  const emptyTags = addedTags.every(
    signatory =>
      signatory.signer_email !== "" &&
      signatory.first_name !== "" &&
      signatory.last_name !== "",
  );

  return !emptySigComp && emptyTags;
};
